// Vehicle Image Mapping — Updated 2026-04-06
// Maps DB vehicle UUIDs to /public/vehicles/ images
// All mappings verified by visual inspection of each PNG file

export const vehicleImageMap = {
  // ── Exact matches ─────────────────────────────────────────────────
  "74188f14-819e-4b67-8186-94f51cedd350": "/vehicles/vehicle-07.png", // خ-89012-06 Peugeot 208 (blue hatchback)
  "9e00df96-aeac-431f-9f0f-3490ccdc4948": "/vehicles/vehicle-11.png", // ش-44444-06 Hyundai Accent (gray sedan)
  "e6d8effa-cc1e-4b10-a227-2dbdd5e195bb": "/vehicles/vehicle-06.png", // ص-55555-06 Kia Picanto (red hatchback)
  "e6e6ca3c-f708-4670-b21e-355c8a438aa4": "/vehicles/vehicle-03.png", // ج-67890-06 Dacia Duster (beige SUV)

  // ── Dacia Logan × 2 ───────────────────────────────────────────────
  "619add88-8ced-4013-8a07-8e7f0e56d15f": "/vehicles/vehicle-10.png", // أ-23456-06 Dacia Logan (white sedan)
  "17c57cd4-b516-444f-a7be-9d713fd61cc3": "/vehicles/vehicle-10.png", // و-12345-06 Dacia Logan (white sedan)

  // ── Renault Clio × 2 ──────────────────────────────────────────────
  "9de89b21-c94c-4b71-96f1-3b98a56ac904": "/vehicles/vehicle-12.png", // ب-34567-06 Renault Clio (silver hatchback)
  "f7fffc2d-c381-4137-bd61-1b528d7ff662": "/vehicles/vehicle-12.png", // ت-45678-06 Renault Clio (silver hatchback)

  // ── Same-brand / same-platform fallbacks ──────────────────────────
  "2dea6ccd-e2c1-414b-ae5a-bd3e7b0287b8": "/vehicles/vehicle-10.png", // ز-22222-06 Dacia Sandero → Logan (same platform)
  "55fbb19e-f1a0-41bc-9d8f-e07ca632f3e2": "/vehicles/vehicle-11.png", // ث-56789-06 Hyundai i10 → Accent (same brand)
  "dd4b5eac-356d-4338-80fc-2f54f41d8981": "/vehicles/vehicle-02.png", // ح-78901-06 Fiat Punto → Tipo (same brand)
  // 2d143419 Renault Kangoo → no van image, falls back to CarIcon SVG

  // ── Brand fallbacks (correct brand, different model) ──────────────
  "abaa36c8-9c59-40e5-aa1b-8fd662d2a13f": "/vehicles/vehicle-09.png", // Volkswagen Polo (exact — gray VW Polo)
  "0236f775-fbc8-4833-9c53-15203948383d": "/vehicles/vehicle-01.png", // Citroen C3 → C-Elysée (Citroën brand)
  "48e49d8c-9159-42c1-a04a-678f06c23d81": "/vehicles/vehicle-04.png", // Toyota Yaris → Corolla (Toyota brand)
};

// Images in /vehicles/ NOT currently mapped (no matching make in fleet):
//   vehicle-05.png — Škoda Octavia
//   vehicle-08.png — Opel Corsa
//
// Vehicles needing new images (for image generation workspace):
//   Renault Kangoo 2020 Utilitaire — needs a van/utility image
//   Dacia Sandero — dedicated image (currently sharing Logan)
//   Hyundai i10 — dedicated image (currently sharing Accent)
//   Fiat Punto — dedicated image (currently sharing Tipo sedan)
//   Citroen C3 hatchback — dedicated image (currently sharing C-Elysée sedan)
//   Toyota Yaris — dedicated image (currently sharing Corolla sedan)
//   VW Polo — exact image exists (vehicle-09), just needs full UUID added here
